import APIService from '@/services/APIService.js';

export default {
  getById(id) {
    return APIService.apiCall().get(`/agings/getById/${id}`);
  },
  getAll() {
    return APIService.apiCall().get('/agings/getAll');
  },
  deletar(id) {
    return APIService.apiCall().get(`/agings/excluir/${id}`);
  },
  executar(id) {
    return APIService.apiCall().get(`/agings/executar/${id}`);
  },
  duplicar(id) {
    return APIService.apiCall().get(`/agings/duplicar/${id}`);
  },
  salvar(postData, id) {
    return APIService.apiCall().post(`/agings/salvar/${id}`, JSON.stringify(postData));
  },
  download(id, config = {}) {
    return APIService.apiCall().get(`/agings/baixar/${id}`, {
      responseType: 'blob',
      ...config
    });
  },
  baixarLogsTecnicos(id, config = {}) {
    return APIService.apiCall().get(`/agings/baixarLogsTecnicos/${id}`, {
      responseType: 'blob',
      ...config
    });
  },
  getDadosPainel(id) {
    return APIService.apiCall().get(`/agings/getDadosPainel/${id}`);
  }
};
